import { differenceInHours, format, isSameDay } from 'date-fns'

import { addDays, formatDate, isEndOfWorkDay, isStartOfWorkDay } from '@/helpers/date'
import { convertDateToDateYearString } from '@/helpers/DateTimeParser'
import { trans } from '@/helpers/trans'
import { DateFormat } from '@/types'

export const getLeaveOfAbsencesDateLabel = (start: Date, end?: Date): string => {
    if (end && isSameDay(start, end)) {
        return `${convertDateToDateYearString(start)} ${format(start, 'HH:mm')} - ${format(end, 'HH:mm')}`
    }

    const formattedStartDate = isStartOfWorkDay(start)
        ? convertDateToDateYearString(start)
        : `${convertDateToDateYearString(start)} ${format(start, 'HH:mm')}`

    if (! end || differenceInHours(end, start) <= 24) {
        return formattedStartDate
    }

    const formattedEndDate = isEndOfWorkDay(end)
        ? convertDateToDateYearString(addDays(end, -1))
        : `${convertDateToDateYearString(end)} ${format(end, 'HH:mm')}`

    return `${formattedStartDate} ${trans('pages.absences.until')} ${formattedEndDate}`
}

export const getLeaveOfAbsencesDateLabelShort = (date?: Date): string => {
    return formatDate(date!, DateFormat.dateWithStandAloneMonthShort)
}
